<template>
  <v-form v-model="valid" @submit.prevent="submit" ref="form" lazy-validation>
    <v-card :class="{ ['elevation-12']: $vuetify.breakpoint.smAndUp }">
      <v-card-title class="display-1">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <v-layout align-center justify-center wrap>
          <v-flex xs12 sm12 md6>
            <v-autocomplete
              :items="kinds"
              :class="{ ['mr-1']: $vuetify.breakpoint.mdAndUp}"
              v-model="value.kind"
              label="Geschäftsart"
              box
              hide-no-data
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm12 md6>
            <v-autocomplete
              :items="statuses"
              :class="{ ['ml-1']: $vuetify.breakpoint.mdAndUp}"
              v-model="value.status"
              label="Status"
              box
              hide-no-data
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-textarea
          v-model="value.title"
          :rules="[$rules.required]"
          :autofocus="$vuetify.breakpoint.smAndUp"
          label="Titel"
          rows="3"
          box
        ></v-textarea>
        <CrudCombobox
          v-model="value.commission_id"
          :model="commissionModel"
        />
        <v-text-field
          v-model="value.number"
          :rules="[$rules.required]"
          label="Geschäftsnummer"
          box
        ></v-text-field>
        <v-text-field
          v-model="value.running_number"
          label="Laufnummer"
          box
        ></v-text-field>
        <v-layout align-center justify-center wrap>
          <v-flex xs12 sm12 md6>
            <v-text-field
              v-model="value.opening_date"
              :rules="[$rules.required, $rules.date]"
              :class="{ ['mr-1']: $vuetify.breakpoint.mdAndUp}"
              label="Eröffnungsdatum"
              type="date"
              box
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md6>
            <v-text-field
              v-model="value.closing_date"
              :class="{ ['ml-1']: $vuetify.breakpoint.mdAndUp}"
              :rules="[$rules.date]"
              label="Abschlussdatum"
              type="date"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-text-field
          v-model="value.publishingDatetime"
          :rules="[$rules.datetime]"
          label="Veröffentlicht per"
          type="datetime-local"
          persistent-hint
          box
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :disabled="!valid"
          type="submit"
          color="primary"
          depressed
        >
          {{ submitText }}
        </v-btn>
        <v-btn
          :to="backLink"
          depressed
        >Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import Business from '@/models/business';
import Commission from '@/models/commission';

export default {
  name: 'BusinessForm',
  props: {
    value: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: () => '',
    },
    submitText: {
      type: String,
      default: () => 'speichern',
    },
    backLink: {
      type: Object,
    },
  },
  data() {
    return {
      kinds: Business.kinds,
      statuses: Business.statuses,
      valid: true,
      commissionModel: Commission,
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$emit('submit');
      }
    },
  },
};
</script>
